<template>
  <v-btn @click.stop="onClick" text small>
    <v-icon id="RTE__command__unorderedList">mdi-format-list-bulleted</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'unorderedList',
  methods: {
    onClick () {
      this.$emit('click', 'insertUnorderedList')
    }
  }
}
</script>

<style scoped>
#RTE__command__unorderedList {
  font-size: 20px;
}
</style>
